/* eslint-env jquery */
import Cookies from 'js-cookie';

const $ = jQuery;
$(document).ready(init);
// eslint-disable-next-line camelcase
$(document).bind('gform_post_render', (event, form_id, current_page) => {
  formatMoneyInput();
  forceCursorPlacement();
  queryParams();

  $('.ginput_container_name.has_first_name ~ .text-danger.small.validation_message').text(
    'First name required'
  );
  $('.ginput_container_name.has_last_name ~ .text-danger.small.validation_message').text(
    'Last name required'
  );

  if ($('.modal:visible')) {
    $('.modal').appendTo('body');
  }

  $('input').each(function () {
    if (
      $(this).attr('type') === 'number' ||
      $(this).attr('autocomplete') === 'postal-code' ||
      this.parentElement.classList.contains('ginput_container_number')
    ) {
      $(this).attr('pattern', '[0-9]*');
    }
  });

  $('input[type="tel"]').each(function () {
    $(this).attr('autocomplete', 'tel');
    $(this).attr('maxlength', '10');
  });

  if ($('.gform_page').length) {
    const visiblePage = $('.gform_page:visible');
    if (visiblePage) {
      // eslint-disable-next-line camelcase
      const pageID = `#gform_page_${form_id}_${current_page}`;
      formButtonValidation(pageID);
      if ($(`${pageID} .gfield.after`).length) {
        insertAfter(pageID, form_id);
      }
    }

    if ($('.submit-button').length) {
      formDisclaimerButton(form_id);
    }
  } else if ($('.gform_wrapper').length) {
    // eslint-disable-next-line camelcase
    const formID = `#gform_${form_id}`;
    if ($(`${formID} .gfield.after`).length) {
      insertAfter(formID, form_id);
    }

    if ($('.submit-button').length) {
      formDisclaimerButton(form_id);
    }
  }
});

function init() {
  formatMoneyInput();
  if ($('.gform_wrapper').length <= 1) {
    const formID = `#${$('.gform_wrapper').prop('id')} `;
    formButtonValidation(formID);
  }

  formBackground();
  gformPageCount();
  gformSelect();
}

function gformPageCount() {
  if ($('.gform_wrapper').length) {
    // eslint-disable-next-line no-undef
    gform.addAction(
      'gform_frontend_pages_evaluated',
      (pages) => {
        let count = 1;
        for (const page of pages) {
          if (page.isVisible) {
            count++;
          }
        }

        if ($('.gf_page_steps').length) {
          $('.gf_page_steps .gf_step_total').text(count);
        }
      },
      10,
      3
    );
  }
}

function gformSelect() {
  if ($('.gform_wrapper').length) {
    // eslint-disable-next-line no-undef
    gform.addAction(
      'gform_input_change',
      (elem) => {
        if ($(elem).is('select')) {
          if (elem.options.selectedIndex === 0) {
            $(elem).addClass('empty');
          } else {
            $(elem).removeClass('empty');
          }
        }
      },
      10
    );
  }
}

function formButtonValidation(pageID) {
  const validateFormInput = () => {
    if (allFilled(pageID)) {
      $('.gform_next_button').attr('disabled', false);
      $('button[type="submit"]').attr('disabled', false);
    } else {
      $('.gform_next_button').attr('disabled', true);
      $('button[type="submit"]').attr('disabled', true);
    }
  };

  // Check Inputs
  $(`${pageID}.gfield.gfield_contains_required input:not([type="hidden"])`).each(function () {
    if ($(this).attr('aria-required') === 'true') {
      validateFormInput();
      $(this).on('keyup blur', validateFormInput);
    }
  });
}

function allFilled(pageID) {
  const split = pageID.split('_');
  const formID = $.trim(split[2]);
  let filled = true;
  $('input[aria-required="true"]').each(function () {
    if ($('.gform_page').length) {
      if ($(this).is(':visible')) {
        let value = '';
        if ($(this).val() !== '') {
          value = $(this).val();
        }

        if ($(this).attr('autocomplete') === 'postal-code') {
          const t = this.id;
          const fieldID = t.replace('input_', '');
          if (value === '') {
            Cookies.remove('SESSzip');
          } else {
            value = value.replace(/[^\d,.]/g, '');
            const zip = Cookies.get('SESSzip');
            // eslint-disable-next-line max-depth
            if (value.length === 5) {
              // eslint-disable-next-line max-depth
              if (zip === undefined || zip !== value) {
                $.ajax({
                  type: 'GET',
                  dataType: 'json',
                  async: false,
                  // eslint-disable-next-line camelcase,no-undef
                  url: `https://us-zipcode.api.smarty.com/lookup?zipcode=${value}&key=${foac_obj.smarty_key}`,
                  headers: {},
                  success(data) {
                    if (data[0].status === 'invalid_zipcode') {
                      filled = false;
                      $(`#${t}`).attr('aria-invalid', 'true');
                      if ($(`#validation_message_${fieldID}`).length === 0) {
                        $(`#field_${fieldID}`).append(
                          `<div id="validation_message_${fieldID}" class="text-danger d-block p-1 small gfield_description validation_message gfield_validation_message">Error: See message above</div>`
                        );
                      }

                      if ($(`#gform_${formID}_validation_container`).length === 0) {
                        $(
                          // eslint-disable-next-line camelcase,no-undef
                          `<div class="gform_validation_errors" id="gform_${formID}_validation_container" data-js="gform-focus-validation-error" tabIndex="-1"><div class="validation_error">${foac_obj.default_error_message}</div></div>`
                        ).insertAfter(`#gf_${formID}`);
                      } else {
                        $('.gform_validation_errors .validation_error').html(
                          // eslint-disable-next-line camelcase,no-undef
                          foac_obj.default_error_message
                        );
                      }
                    } else if (data[0].city_states[0].state_abbreviation === 'NY') {
                      filled = false;
                      $(`#${t}`).attr('aria-invalid', 'true');
                      if ($(`#validation_message_${fieldID}`).length === 0) {
                        $(`#field_${fieldID}`).append(
                          `<div id="validation_message_${fieldID}" class="text-danger d-block p-1 small gfield_description validation_message gfield_validation_message">Error: See message above</div>`
                        );
                      }

                      if ($(`#gform_${formID}_validation_container`).length === 0) {
                        $(
                          // eslint-disable-next-line camelcase,no-undef
                          `<div class="gform_validation_warning" id="gform_${formID}_validation_container" data-js="gform-focus-validation-error" tabIndex="-1"><div class="validation_warning">${foac_obj.ny_error_message}</div></div>`
                        ).insertAfter(`#gf_${formID}`);
                        $(
                          `<a id="gform_${formID}_validation_button" class="btn btn-interactive btn-lg validation-button" href="https://www.far.com"><span>Visit Far.com</span><i class="fa fa-arrow-right"></i></a>`
                        ).insertAfter(`#gform_${formID}_validation_container`);
                      } else {
                        $('.gform_validation_errors .validation_error').html(
                          // eslint-disable-next-line camelcase,no-undef
                          foac_obj.ny_error_message
                        );
                        if ($(`#gform_${formID}_validation_button`).length === 0) {
                          $(
                            `<a id="gform_${formID}_validation_button" class="btn btn-interactive btn-lg validation-button" href="https://www.far.com"><span>Visit Far.com</span><i class="fa fa-arrow-right"></i></a>`
                          ).insertAfter(`#gform_${formID}_validation_container`);
                        }
                      }
                    } else {
                      Cookies.set('SESSzip', value);
                      $(`#${t}`).attr('aria-invalid', 'false');
                      $(`#gform_${formID}_validation_container`).remove();
                      $(`#gform_${formID}_validation_button`).remove();
                      $(`#validation_message_${fieldID}`).remove();
                      $(`${pageID} .gfield.state input`).attr(
                        'value',
                        data[0].city_states[0].state_abbreviation
                      );
                    }
                  },
                  error() {
                    filled = false;
                  }
                });
              } else {
                filled = true;
              }
            }
          }
        }
      }
    } else {
      let value = '';
      if ($(this).val() !== '') {
        value = $(this).val();
      }

      if ($(this).attr('autocomplete') === 'postal-code') {
        const t = this.id;
        const fieldID = t.replace('input_', '');
        if (value === '') {
          Cookies.remove('SESSzip');
        } else {
          value = value.replace(/[^\d,.]/g, '');
          const zip = Cookies.get('SESSzip');
          if (value.length === 5) {
            // eslint-disable-next-line max-depth
            if (zip === undefined || zip !== value) {
              $.ajax({
                type: 'GET',
                dataType: 'json',
                async: false,
                // eslint-disable-next-line camelcase,no-undef
                url: `https://us-zipcode.api.smarty.com/lookup?zipcode=${value}&key=${foac_obj.smarty_key}`,
                headers: {},
                success(data) {
                  if (data[0].status === 'invalid_zipcode') {
                    filled = false;
                    $(`#${t}`).attr('aria-invalid', 'true');
                    if ($(`#validation_message_${fieldID}`).length === 0) {
                      $(`#field_${fieldID}`).append(
                        `<div id="validation_message_${fieldID}" class="text-danger d-block p-1 small gfield_description validation_message gfield_validation_message">Error: See message above</div>`
                      );
                    }

                    if ($(`#gform_${formID}_validation_container`).length === 0) {
                      $(
                        // eslint-disable-next-line camelcase,no-undef
                        `<div class="gform_validation_errors" id="gform_${formID}_validation_container" data-js="gform-focus-validation-error" tabIndex="-1"><div class="validation_error">${foac_obj.default_error_message}</div></div>`
                      ).prependTo(`#gform_wrapper_${formID}`);
                    } else if ('.gform_validation_error'.length === 0) {
                      $('.gform_validation_errors .validation_error').html(
                        // eslint-disable-next-line camelcase,no-undef
                        foac_obj.default_error_message
                      );
                    } else {
                      $(`#gform_${formID}_validation_container`)
                        .removeClass('gform_validation_warning')
                        .addClass('gform_validation_errors')
                        .removeAttr('data-js')
                        .attr('data-js', 'gform-focus-validation-error');
                      $(`#gform_${formID}_validation_container .validation_warning`)
                        .removeClass('validation_warning')
                        .addClass('validation_error');
                      if ($(`#gform_${formID}_validation_button`).length) {
                        $(`#gform_${formID}_validation_button`).remove();
                      }

                      $('.gform_validation_errors .validation_error').html(
                        // eslint-disable-next-line camelcase,no-undef
                        foac_obj.default_error_message
                      );
                    }
                  } else if (data[0].city_states[0].state_abbreviation === 'NY') {
                    filled = false;
                    $(`#${t}`).attr('aria-invalid', 'true');

                    if ($(`#validation_message_${fieldID}`).length === 0) {
                      $(`#field_${fieldID}`).append(
                        `<div id="validation_message_${fieldID}" class="text-danger p-1 small gfield_description validation_message gfield_validation_message">Error: See message above</div>`
                      );
                    }

                    if ($(`#gform_${formID}_validation_container`).length === 0) {
                      $(
                        // eslint-disable-next-line camelcase,no-undef
                        `<div class="gform_validation_warning" id="gform_${formID}_validation_container" data-js="gform-focus-validation-warning" tabIndex="-1"><div class="validation_warning">${foac_obj.ny_error_message}</div></div>`
                      ).prependTo(`#gform_wrapper_${formID}`);
                    } else if ('.gform_validation_warning'.length === 0) {
                      $('.gform_validation_warning .validation_warning').html(
                        // eslint-disable-next-line camelcase,no-undef
                        foac_obj.ny_error_message
                      );
                    } else {
                      $(`#gform_${formID}_validation_container`)
                        .removeClass('gform_validation_errors')
                        .addClass('gform_validation_warning')
                        .removeAttr('data-js')
                        .attr('data-js', 'gform-focus-validation-warning');
                      $(`#gform_${formID}_validation_container .validation_error`)
                        .removeClass('validation_error')
                        .addClass('validation_warning');

                      $('.gform_validation_warning .validation_warning').html(
                        // eslint-disable-next-line camelcase,no-undef
                        foac_obj.ny_error_message
                      );
                    }
                  } else {
                    Cookies.set('SESSzip', value);
                    $(`#${t}`).attr('aria-invalid', 'false');
                    $(`#gform_${formID}_validation_container`).remove();
                    $(`#validation_message_${fieldID}`).remove();
                    $(`${pageID} .gfield.state input`).attr(
                      'value',
                      data[0].city_states[0].state_abbreviation
                    );
                  }
                },
                error() {
                  filled = false;
                }
              });
            } else {
              filled = true;
            }
          }
        }
      }
    }
  });

  return filled;
}

function formatMoneyInput() {
  const formatMoney = $('.format-money input');
  if (formatMoney.length) {
    formatMoney.on('input', function () {
      const _t = $(this);
      _t.val(numberWithCommas(_t.val().replace(/[$,]/g, '')));
    });
  }
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function insertAfter(pageID, formID) {
  // Check if 'form-disclaimer' already exists in the document
  if ($(`.form-disclaimer-${formID}`).length === 0) {
    if ($('.gform_page_footer').length) {
      $(`${pageID} .gfield.after`).appendTo(`${pageID} .gform_page_footer`).show();
    } else if ($(`.form-holder-${formID}`).length) {
      $(`${pageID} .gfield.after`)
        .insertAfter(`.form-holder-${formID}`)
        .show()
        .addClass(`form-disclaimer form-disclaimer-${formID}`);
    } else {
      $(`${pageID} .gfield.after`).appendTo(`${pageID} .gform_footer`).show();
    }
  }
}

function forceCursorPlacement() {
  const inputsMasked = document.querySelectorAll('.gfield.force-cursor input');

  let i;
  for (i = 0; i < inputsMasked.length; ++i) {
    inputsMasked[i].addEventListener('mouseup', (e) => {
      if (e.currentTarget.value.replace(/[()._-]/g, '').trim() === '') {
        e.currentTarget.setSelectionRange(0, 0);
      }
    });
  }
}

function queryParams() {
  const params = window.localStorage.getItem('custom-params');
  const url = new URL(window.location.href);
  if (url) {
    $('.page-url textarea').text(url);
  }

  const formQueryString = window.location.search.slice(1);
  if (formQueryString !== '') {
    $('.query-params textarea').text(formQueryString);
  }

  const queryString = window.location.search.slice(1).split('&');
  let obj = {};
  let pair;
  let i;
  if (queryString[0] === '') {
    if (params !== null) {
      obj = JSON.parse(params);
    }
  } else {
    for (i in queryString) {
      if (queryString[i] === '') {
        continue;
      }

      pair = queryString[i].split('=');
      obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }

    const origObj = JSON.stringify(obj);
    window.localStorage.setItem('orig-params', origObj);

    for (const param of Object.keys(obj)) {
      if (param.indexOf('utm_') === 0) {
        delete obj[param];
      }
    }

    const customObj = JSON.stringify(obj);
    window.localStorage.setItem('custom-params', customObj);
    Cookies.set('SESSparams', 'a', { expires: 30 });
  }

  if (Object.keys(obj).length === 0) {
    Cookies.remove('SESSparams');
  } else {
    for (const param of Object.keys(obj)) {
      const value = obj[param];
      if ($('form[id^=gform_]').length) {
        $('div.gfield_aqGoogleAnalytics').append(
          `<input type='hidden' name='${param}' id='${param}' value='${value}' class='gform_hidden'>`
        );
      }
    }
  }
}

function formDisclaimerButton(formID) {
  const buttonText = $(`#gform_submit_button_${formID}`).text();
  if ($(`.form-disclaimer-${formID}`).length) {
    $(`.form-disclaimer-${formID} .submit-button`).replaceWith(`"${buttonText}"`);
  } else {
    $(`#gform_${formID} .submit-button`).replaceWith(`"${buttonText}"`);
  }
}

export default formButtonValidation;

function formBackground() {
  const $lazyBackgrounds = $('.lazy-bg');

  const observer = new IntersectionObserver((entries, observer) => {
    $.each(entries, (index, entry) => {
      if (entry.isIntersecting) {
        const bgUrl = $(entry.target).data('bg');
        if (bgUrl) {
          $(entry.target).css('background-image', `url("${bgUrl}")`);
        }

        observer.unobserve(entry.target);
      }
    });
  });

  $lazyBackgrounds.each(function () {
    observer.observe(this);
  });
}
